/**
    How to setup a route can be found here:
    https://github.homeawaycorp.com/traveler/node-traveler-property-ui/wiki/Routing
*/
import qs from 'query-string';

import RouterActions from '../actions/routerActions';
import ListingActions from '../actions/listingActions';
import {OpenModalStates} from '../records/listingPageRecord';
import {resetStateOnForceClose as resetDatePickerStateOnForceClose} from './datePicker';
import tripActions from '../actions/tripActions';

function navigate(store, action) {
    const {updatedParams, options: passedOptions} = action.payload;

    const defaultOptions = {type: 'push', persist: false};
    const options = {...defaultOptions, ...passedOptions};

    const pushOrReplace =
        options.type === 'push' ? RouterActions.routerPush : RouterActions.routerReplace;

    let newParams = {};

    const removeFalsyValues = (obj) => {
        Object.keys(obj).forEach((key) => !obj[key] && delete obj[key]);
        return obj;
    };

    if (options.persist) {
        const currentParams = qs.parse(window.location.search);
        newParams = {...currentParams, ...updatedParams};
    } else {
        newParams = updatedParams;
    }

    const navigationAction = pushOrReplace({
        query: removeFalsyValues(newParams)
    });

    store.dispatch({
        ...navigationAction,
        ...(options.limit ? {meta: {limit: options.limit}} : {})
    });
}

function syncModalStateWithRoute(store, action = {payload: {}}) {
    const {query} = action.payload;
    const {dispatch, getState} = store;

    const {
        listingPageReducer: {openModalState},
        systemReducer: {isMobile},
        router
    } = getState();

    const previousModalRoute = router.query.r || OpenModalStates.NONE;
    const nextModalRoute = query.r || OpenModalStates.NONE;

    // This if statement will execute if the URL has updated independently of the redux store
    // which can happen if the back/forward button is pressed. This updates the redux store
    // to match the URL.
    if (isMobile && previousModalRoute !== nextModalRoute && openModalState !== nextModalRoute) {
        // if back/forward button clicked

        // On close hooks
        switch (previousModalRoute) {
            case OpenModalStates.INQUIRY:
                dispatch(ListingActions.resetInquiryState());
                break;
            case OpenModalStates.MAP:
                dispatch(ListingActions.resetMapState());
                break;
            case OpenModalStates.TOI_MAP:
                dispatch(ListingActions.resetMapState());
                break;
            case OpenModalStates.BOOKING_FLOW_DATE_PICKER:
            case OpenModalStates.DATE_PICKER:
            case OpenModalStates.INQUIRY_DATE_PICKER:
            case OpenModalStates.MAIN_PAGE_DATE_PICKER:
            case OpenModalStates.REQUEST_TO_BOOK_DATE_PICKER:
                resetDatePickerStateOnForceClose(store);
                break;
            case OpenModalStates.GUEST_SELECTOR:
            case OpenModalStates.REQUEST_TO_BOOK_GUEST_SELECTOR:
            case OpenModalStates.INQUIRY_GUEST_SELECTOR:
            case OpenModalStates.MAIN_PAGE_GUEST_SELECTOR:
            case OpenModalStates.BOOKING_FLOW_GUEST_SELECTOR:
                dispatch(tripActions.setBookingFlow(false));
                break;
            default:
                break;
        }

        // don't let them navigate to guest selector or date picker with forward and back, it just gets weird
        switch (nextModalRoute) {
            case OpenModalStates.BOOKING_FLOW_DATE_PICKER:
            case OpenModalStates.DATE_PICKER:
            case OpenModalStates.INQUIRY_DATE_PICKER:
            case OpenModalStates.MAIN_PAGE_DATE_PICKER:
            case OpenModalStates.REQUEST_TO_BOOK_DATE_PICKER:
            case OpenModalStates.GUEST_SELECTOR:
            case OpenModalStates.REQUEST_TO_BOOK_GUEST_SELECTOR:
            case OpenModalStates.INQUIRY_GUEST_SELECTOR:
            case OpenModalStates.MAIN_PAGE_GUEST_SELECTOR:
            case OpenModalStates.BOOKING_FLOW_GUEST_SELECTOR:
                dispatch(ListingActions.updateModalState(OpenModalStates.NONE));
                return;
            default:
                break;
        }

        dispatch(ListingActions.updateModalState(nextModalRoute));
    }
}
function updateUrlAfterModalChange(store, action = {payload: {}}) {
    // Redux store is source of truth for modals. Update URL when redux store is updated to match
    const isMobile = store.getState().systemReducer.isMobile;
    const currentUrlModalState = qs.parse(window.location.search).r || OpenModalStates.NONE;
    const currentModalState = action.payload.modalState || OpenModalStates.NONE;

    if (isMobile && currentUrlModalState !== currentModalState) {
        let navigationType = 'push';
        if (currentModalState === OpenModalStates.NONE) {
            store.dispatch(RouterActions.navigateToModal(null, 'replace'));
        } else {
            store.dispatch(RouterActions.navigateToModal(currentModalState, navigationType));
        }
    }
}

export {syncModalStateWithRoute, navigate, updateUrlAfterModalChange};
